"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAppBarLogo = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const helpers_1 = require("../../../helpers");
exports.StyledAppBarLogo = styled_components_1.default.img `
    flex-shrink: 0;
    display: block;
    width: auto;
    height: ${helpers_1.SIZE_XL};
    min-height: ${helpers_1.SIZE_XL};
    max-height: ${helpers_1.SIZE_XL};
    overflow: hidden;
    padding: 0;
    margin: 0;
    background-color: transparent;
    border: 0;
    outline: none;
    cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
`;
//# sourceMappingURL=AppBarLogo.styles.js.map